"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHelper = void 0;
var $ = require("jquery");
var LoginStatus = (function () {
    function LoginStatus() {
    }
    return LoginStatus;
}());
var AuthHelper = (function () {
    function AuthHelper() {
    }
    AuthHelper.setupPage = function () {
        var _this = this;
        var cachedStatus = this.getCachedStatus();
        if (cachedStatus == null) {
            $.get("/Identity/Status")
                .done(function (data) { _this.handleStatusCheck(data); })
                .fail(this.showNoAuthState);
            return;
        }
        this.setupPageWithStatus(cachedStatus);
    };
    AuthHelper.setupPageWithStatus = function (status) {
        if (status.isLoggedIn) {
            this.showAuthState(status);
            this.loggedIn = true;
        }
        else {
            this.showNoAuthState();
        }
        this.admin = true;
        for (var i = 0; i < this.callbacks.length; i++) {
            this.callbacks[i](this.loggedIn, this.admin);
        }
        this.callbacks = null;
    };
    AuthHelper.getCachedStatus = function () {
        var cache = sessionStorage.getItem(AuthHelper.authCacheName);
        if (cache == null) {
            return null;
        }
        var cachedStatus = JSON.parse(cache);
        if (cachedStatus.expirationTime < Date.now()) {
            AuthHelper.clearAuthCache();
            return null;
        }
        return cachedStatus;
    };
    AuthHelper.showNoAuthState = function () {
        $("#navLoggedIn").css("display", "none");
        $("#navLogin").css("display", "");
    };
    AuthHelper.showAuthState = function (status) {
        $("#navLogin").css("display", "none");
        $("#navLoggedInUser").text("@" + status.username);
        $("#navLoggedIn").css("display", "");
    };
    AuthHelper.handleStatusCheck = function (data) {
        var status = new LoginStatus();
        status.isLoggedIn = data.loggedIn == true;
        status.expirationTime = Date.now() + 1000 * 60 * 5;
        if (status.isLoggedIn) {
            status.username = data.name;
        }
        sessionStorage.setItem(AuthHelper.authCacheName, JSON.stringify(status));
        this.setupPageWithStatus(status);
    };
    AuthHelper.clearAuthCache = function () {
        sessionStorage.removeItem(AuthHelper.authCacheName);
    };
    AuthHelper.registerAuthHandler = function (handler) {
        if (this.callbacks == null) {
            handler(this.loggedIn, this.admin);
        }
        else {
            this.callbacks.push(handler);
        }
    };
    AuthHelper.authCacheName = "authCache";
    AuthHelper.callbacks = [];
    return AuthHelper;
}());
exports.AuthHelper = AuthHelper;
$(function () {
    if (!window.location.pathname.toLocaleLowerCase().startsWith('/identity')) {
        AuthHelper.setupPage();
    }
    else {
        AuthHelper.clearAuthCache();
    }
});

//# sourceMappingURL=AuthHelper.js.map
